
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycabserviceinnavymumbai() {



const cardData =
{
  keyword: 'Monthly Cab Service in Navi Mumbai',
  heading: 'eTravo: Monthly Cab Service in Navi Mumbai for Corporates and Employees',
  headingDescription: 'eTravo offers professional and fully customizable monthly cab rental services in Navi Mumbai for businesses, corporate teams, and individual professionals. Whether you require cabs for daily employee commutes, long-term executive mobility, or airport transfers, our monthly packages provide reliability, affordability, and comfort. From economic hatchbacks to executive sedans and SUVs, our fleet is managed by trained chauffeurs with GPS-enabled monitoring, real-time support, and regular maintenance. Ideal for IT parks, industrial zones, and corporate campuses, eTravo’s monthly cab plans ensure your workforce stays mobile and productive.',

  top: 'Top Corporate Areas in Navi Mumbai Served by eTravo’s Monthly Cab Plans',
  topPlaces: [
    {
      title: 'Vashi Infotech Park',
      description: 'Vashi is the commercial heart of Navi Mumbai, housing IT offices, startups, and BPOs. Our monthly cab services are widely used here for seamless staff pickup and drop, senior executive travel, and shift-based corporate cab scheduling.'
    },
    {
      title: 'CBD Belapur',
      description: 'CBD Belapur is a prime government and business district with court offices, administrative HQs, and consulting firms. eTravo serves this region with executive cab rentals and recurring subscription plans for company directors and legal staff.'
    },
    {
      title: 'Airoli Mindspace',
      description: 'An IT-dominated area with tech giants like Capgemini and Accenture. We provide structured long-term cab services here, including multi-batch daily commute solutions, vehicle tracking, and 24/7 fleet support for round-the-clock operations.'
    },
    {
      title: 'Turbhe MIDC',
      description: 'A key industrial zone requiring high-volume employee transport. Our monthly cab solutions here are designed for factory workers, office staff, and managers, offering safe and timely cab access every day.'
    },
    {
      title: 'Kharghar Sector 7–35',
      description: 'A residential-commercial hybrid zone with educational hubs and business offices. Our subscription-based cab plans offer fixed-time pickups and flexible routing, ensuring convenience for both companies and staff residing in Kharghar.'
    },
    {
      title: 'Seawoods Grand Central',
      description: 'A modern commercial hub with premium offices and coworking spaces. Our executive monthly cab rentals in Seawoods are used for luxury corporate travel, boardroom meetings, and visitor logistics.'
    },
    {
      title: 'Nerul',
      description: 'One of Navi Mumbai’s oldest and most established areas. We serve many educational institutions, media houses, and small-scale businesses here with affordable and consistent cab options on monthly contracts.'
    },
    {
      title: 'Kopar Khairane',
      description: 'Popular among mid-level offices and logistics companies, this area benefits from eTravo’s budget monthly cab plans designed to balance affordability with service quality for employee transport.'
    },
    {
      title: 'Panvel Industrial & Logistic Parks',
      description: 'Strategically located for port-related industries and logistics operations, Panvel requires highly dependable long-term cab solutions. Our fleet services this region daily with route-based scheduling and cargo-supporting staff transfers.'
    },
    {
      title: 'Navi Mumbai International Airport (NMIA – upcoming)',
      description: 'Our monthly airport pickup and drop packages are already planned for business teams and flight crew working near Navi Mumbai’s future airport hub, ensuring readiness for corporate aviation travel.'
    }
  ],

  services: [
    {
      name: 'Navi Mumbai Corporate Monthly Cab Rentals',
      description: 'Customized monthly cab rental packages for corporates in Navi Mumbai, designed to support daily commutes, inter-office travel, and executive transport with flexible contracts and dedicated vehicles under a single invoice.'
    },
    {
      name: 'Long-Term Cab Service for Employees Navi Mumbai',
      description: 'Ideal for organizations running shifts or multiple office branches. We manage employee cab movement through full-month route planning, driver allocation, and consistent service backup—even during weekends and holidays.'
    },
    {
      name: 'Monthly Business Cab Hire Navi Mumbai',
      description: 'eTravo’s business cab plans offer structured travel for marketing professionals, field staff, and service engineers. These plans support on-demand daily travel across Navi Mumbai without requiring repetitive bookings.'
    },
    {
      name: 'Affordable Monthly Corporate Cabs Navi Mumbai',
      description: 'We offer cost-effective cab plans tailored for small businesses and growing startups. These include budget vehicles, fuel-efficient routing, cab options, and easy modifications during the month.'
    },
    {
      name: 'Reliable Employee Cab Service Navi Mumbai',
      description: 'Reliability is key when transporting employees daily. Our team assigns consistent drivers, uses route-tracking technology, and offers helpdesk access for real-time trip adjustments and support.'
    },
    {
      name: 'Executive Monthly Cab Rentals Navi Mumbai',
      description: 'Luxury cab plans for CEOs, VPs, and foreign guests. Features include rear-seat AC control, ambient interiors, bottled water, and priority pickup handling with trained, uniformed chauffeurs.'
    },
    {
      name: 'Monthly Staff Commute Navi Mumbai',
      description: 'Shift-based commuting made simple with route-wise cab dispatches. Suitable for IT parks and manufacturing units, this plan includes morning-evening schedules, grouped pickups, and regular updates to HR/admin teams.'
    },
    {
      name: 'Corporate Lease Cab Navi Mumbai',
      description: 'Our leasing plans are perfect for companies that want access to a fleet without owning vehicles. Includes licensed drivers, cab replacement guarantees, fuel management options, and insurance.'
    },
    {
      name: 'Monthly Airport Pickup Navi Mumbai',
      description: 'Ensure consistent airport pickups and drops with 24x7 availability, professional greeting, flight tracking, and premium cabs for clients, staff, or partners commuting from domestic and international terminals.'
    },
    {
      name: 'Monthly Cab for Business Trips Navi Mumbai',
      description: 'For sales teams or consultants who travel extensively within and outside the city, we offer long-term cab rental packages covering intercity visits, multi-location days, and roundtrip bookings under a single plan.'
    },
    {
      name: 'Corporate Subscription Cab Navi Mumbai',
      description: 'A modern model for businesses needing continuous cab availability. Subscribe to fixed monthly packages with adjustable distance coverage, priority dispatch, and 100% usage tracking.'
    },
    {
      name: 'Flexible Monthly Cab Plans Navi Mumbai',
      description: 'Plans that grow with your business. Add more vehicles mid-month, change routes or driver timing, and adjust pickup points—all through a centralized eTravo dashboard accessible to your admin team.'
    },
    {
      name: 'Long-Term Employee Cab Navi Mumbai',
      description: 'Essential for employee retention and punctuality. Our long-term plans ensure daily comfort, AC ride quality, verified drivers, and minimized delays across routes in Navi Mumbai.'
    },
    {
      name: 'Monthly VIP Cab Navi Mumbai',
      description: 'Elite cab service for high-ranking officials and valued guests. Cab interiors include leather seats, privacy screens, personal AC vents, and trained chauffeurs skilled in formal interactions.'
    },
    {
      name: 'Business Monthly Cab Navi Mumbai',
      description: 'For continuous movement of business professionals—be it internal meetings, vendor visits, or partnership tours. All plans include backup cab support, GST billing, and monthly reporting.'
    }
  ],

  tableData: [
    ['Navi Mumbai Corporate Monthly Cab Rentals', 'Long-Term Cab Service for Employees Navi Mumbai'],
    ['Monthly Business Cab Hire Navi Mumbai', 'Affordable Monthly Corporate Cabs Navi Mumbai'],
    ['Reliable Employee Cab Service Navi Mumbai', 'Executive Monthly Cab Rentals Navi Mumbai'],
    ['Monthly Staff Commute Navi Mumbai', 'Corporate Lease Cab Navi Mumbai'],
    ['Monthly Airport Pickup Navi Mumbai', 'Monthly Cab for Business Trips Navi Mumbai'],
    ['Corporate Subscription Cab Navi Mumbai', 'Flexible Monthly Cab Plans Navi Mumbai'],
    ['Long-Term Employee Cab Navi Mumbai', 'Monthly VIP Cab Navi Mumbai'],
    ['Business Monthly Cab Navi Mumbai', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Monthly Cab Service for Navi Mumbai Corporates",
        "WhyChoosedescription": "eTravo delivers dedicated monthly cab rental services across Navi Mumbai’s business zones, catering to companies, IT parks, and manufacturing units with seamless employee and executive transportation."
    },
    {
        "WhyChooseheading": "Fleet Suitable for All Corporate Needs",
        "WhyChoosedescription": "From hatchbacks for operational staff to sedans and SUVs for executives, our diverse fleet supports daily commutes, site visits, and inter-office travel throughout Navi Mumbai."
    },
    {
        "WhyChooseheading": "Dedicated Driver and Vehicle Assignments",
        "WhyChoosedescription": "Each company is assigned fixed drivers and cabs, ensuring consistent service, punctuality, and familiarity with your preferred routes and schedules."
    },
    {
        "WhyChooseheading": "Flexible Plans with No Long-Term Commitment",
        "WhyChoosedescription": "Book vehicles monthly with the flexibility to scale up or down as needed. No long-term contracts—only reliable, pay-as-you-go transport solutions."
    },
    {
        "WhyChooseheading": "Fuel and Non-Fuel Packages Available",
        "WhyChoosedescription": "Choose between fuel-inclusive plans for simplicity or non-fuel plans for internal fuel management—ensuring your billing aligns with your accounting model."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Vehicles",
        "WhyChoosedescription": "Our cabs are sanitized daily, GPS-enabled, and equipped with first-aid kits, fire extinguishers, and seat belts—ensuring safety and hygiene for your staff."
    },
    {
        "WhyChooseheading": "Real-Time Monitoring and Admin Dashboard",
        "WhyChoosedescription": "Track vehicle movements, receive live ETAs, and access usage reports via our centralized dashboard. Ideal for HR and admin teams managing large workforces."
    },
    {
        "WhyChooseheading": "GST Billing with Detailed Usage Reports",
        "WhyChoosedescription": "We provide monthly GST-compliant invoices with complete travel logs, cost breakdowns, and reporting support for budgeting, audits, and reimbursements."
    }
]
}


const faqData = [
    [
        {
            question: 'Which areas in Navi Mumbai are covered under the monthly cab service?',
            answer: 'eTravo covers all major areas including Vashi, Belapur, Nerul, Airoli, Ghansoli, Taloja, and Turbhe for corporate monthly transport.'
        },
        {
            question: 'Can we request a fixed driver for the month?',
            answer: 'Yes, we assign dedicated drivers and vehicles for monthly rentals to ensure familiarity, punctuality, and comfort for your team.'
        },
        {
            question: 'Are vehicles available for shift-based corporate needs?',
            answer: 'Absolutely. We offer shift-based monthly rentals with fleet rotation and multiple time-slot scheduling options for manufacturing and IT clients.'
        },
        {
            question: 'Is real-time cab tracking provided?',
            answer: 'Yes, all vehicles are GPS-enabled, allowing your admin teams to track live location, monitor performance, and access route data anytime.'
        },
        {
            question: 'Can we opt for a fuel-exclusive package?',
            answer: 'Yes, both fuel-inclusive and exclusive billing plans are available to fit your corporate fuel reimbursement policies.'
        },
        {
            question: 'Do you offer monthly GST-compliant invoicing?',
            answer: 'Yes, all clients receive GST-compliant digital invoices with detailed ride summaries and trip logs for financial reporting and audit.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Vishal Gokhale',
        designation: 'Transport Officer, Techridge Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s monthly cab service in Navi Mumbai for our sales team. The service is dependable, cost-effective, and comes with excellent coordination support.”'
    },
    {
        name: 'Ms. Sujata Kulkarni',
        designation: 'Admin Executive, Navizon Infra Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cabs are always clean, drivers are punctual, and their monthly billing helps us maintain perfect expense tracking. Great partner for daily corporate travel.”'
    }
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Service in Navi Mumbai",
  "image": "https://www.etravo.in/images/keyword/monthly-cab-service-navi-mumbai.jpg",
  "description": "Book monthly cab service in Navi Mumbai for corporate employees and business travel. Affordable, reliable, and flexible long-term cab rentals with professional drivers and executive plans by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7598"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-cab-service-navi-mumbai"
  }
};






    return (
        <div>
<Helmet>
  <title>Monthly Cab Service in Navi Mumbai | Corporate & Executive Monthly Hire | eTravo</title>
  <meta 
    name="description" 
    content="Hire monthly cabs in Navi Mumbai for corporate employees, long-term leases, and executive travel. Reliable and affordable corporate cab rentals by eTravo with flexible plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycabserviceinnavymumbai;